var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function Filters(el) {
	var t = this;
	t.$el = $(el);
	t.$posts = $('.js-directory-post-filters').children();
	t.$maps = $('.js-directory-map-filters svg').children();
	t.$cards = $('.js-card-filters').children();

	if ( t.$posts.length ) {
		t.$activePost = t.$posts.filter('.directory__item--active');
	}
	if ( t.$maps.length ) {
		t.$activeMap = t.$maps.filter('js-active');
	}

	if ( t.$cards.length ) {
		t.$activeCard = t.$cards.filter('.small-card--active');
	}
}

Filters.prototype.filterByValue = function(value) {
	var t = this;

	if( t.activeFilter == value ) {
		return;
	}

	if( t.$posts.length ) {
		t.filterPost(value);
	}

	if( t.$maps.length ) {
		t.filterMap(value);
	}

	if( t.$cards.length ) {
		t.filterCard(value);
	}

	t.activeFilter = value;
};

Filters.prototype.filterPost = function(value) {
	var t = this;
	t.$activePost.removeClass('directory__item--active');
	t.$posts.removeClass('directory__item--active')
	t.$activePost = $(value.split('|').map(function(singleValue) {
		var $newPosts = t.$posts.filter( '[data-filter-type*="|' + singleValue + '|"]' );
		$newPosts.addClass('directory__item--active');
	}));
};

Filters.prototype.filterMap = function(value) {
	var t = this;
	t.$maps.removeClass('js-active');
	t.$activeMap = $(value.split('|').map(function(singleValue) {
		var $newMap = t.$maps.filter( '[data-filter*="' + singleValue + '"]' );
		$newMap.addClass('js-active');
		return $newMap;
	}));
};

Filters.prototype.filterCard = function(value) {
	var t = this;

	if( value == 'all' ) {
		t.$el.addClass('card-filter-all');
		t.$cards.addClass('small-card--active');
	} else {
		t.$el.removeClass('card-filter-all');
		t.$cards.removeClass('small-card--active');
		t.$newCard = t.$cards.filter( '[data-filter-type*="|' + value + '|"]' );
		t.$activeCard.removeClass('small-card--active');
		t.$newCard.addClass('small-card--active');
		t.$activeCard = t.$newCard;
	}
};

module.exports = Filters;
